// extracted by mini-css-extract-plugin
export var layoutContainer = "_4k-0";
export var layoutContainerNoRounding = "_4k-6";
export var layoutContainerOpen = "_4k-5";
export var layoutContainerResizing = "_4k-1";
export var mainContent = "_4k-2";
export var resizeDivider = "_4k-3";
export var slidePanel = "_4k-4";